module.exports = __webpack_public_path__ + "static/img/R1612T_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/R1612T_1.png
// module id = W+Lr
// module chunks = 0